export const ExamModeRoutes = {
  consentPrefix: "/exm/consent/",
  paperPrefix: "/exm/paper/",
};

export const isExamModeRoute = (pathname = "") =>
  pathname.startsWith(ExamModeRoutes.consentPrefix) ||
  pathname.startsWith(ExamModeRoutes.paperPrefix);

export const isExamFlowView = (view = "") =>
  view === "consent" || view === "paper";

export const isExamModeActive = (pathname = "", view = "") =>
  isExamModeRoute(pathname) || isExamFlowView(view);

